/* Вид плавающей панели — общий с поповером, см. `../surface.module.css`. */
.content {
  composes: floating from '../surface.module.css';
}

/*
 * Строчный пункт меню — обобщение по образцу строк поповера компании
 * (prototype/Prototype.dc.html:147-161): `padding:8px 10px;border-radius:10px`, hover `--sunk`.
 * Ни один узел макета не является буквально пунктом выпадающего меню — это синтез близких
 * паттернов, не перенос одного места 1:1.
 */
.item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
  cursor: pointer;
  outline: none;
  user-select: none;
}

.item[data-highlighted] {
  background: var(--sunk);
}

.item[data-disabled] {
  color: var(--ink-4);
  cursor: not-allowed;
}

/*
 * Деструктивный вариант — hover «Выйти» в поповере профиля (prototype/Prototype.dc.html:225).
 *
 * Текст `--ink`, иконка `--st-cancel`: тот же разбор, что у живого близнеца этой пары в
 * `widgets/app-header/ui/ProfileMenu.module.css` (там он расписан целиком). Коротко: красный
 * текст на заливке из своего же красного даёт 4.31 : 1 при норме 4.5 — пятый случай правила 2,
 * до которого макет пока не дошёл. Красными остаются заливка и иконка.
 */
.item.danger[data-highlighted] {
  background: color-mix(in oklch, var(--st-cancel) 12%, var(--tint-on));
  color: var(--ink);
}
.item.danger[data-highlighted] .dangerIcon {
  color: var(--st-cancel);
}

/* Разделитель — divider внутри поповера компании (prototype/Prototype.dc.html:162), 1:1. */
.separator {
  height: 1px;
  background: var(--line-2);
  margin: 7px 4px;
  border: 0;
}
